import React, { useRef } from "react";
import {usePagination, useQueryRules} from "react-instantsearch";
import CustomPagination from "../../Pagination/CustomPagination";
import { useDispatch, useSelector } from "react-redux";
import CurrentRefinementsList from "../../CurrentRefinements/CurrentRefinementsList";
import NoResults from "../../NoResults/NoResults";
import NoResultsBoundary from "../../NoResults/NoResultsBoundary";
import ManufacturerSlider from "../../Slider/ManufacturerSlider";
import ListingBanner from "../../Listing/Banner";
import CustomHits from "../CustomHits";
import "./HitListing.scss";
import { useMediaQuery } from "react-responsive";

const HitListing = (props) => {
    const { SEARCH_INDEX } = useSelector((state) => state.config);

    const { canRefine } = usePagination(props);

    const isNotMobile = useMediaQuery({
        query: "(min-width: 768px)",
    });

    const { items } = useQueryRules(props);

    const manufacturerElements =
        items &&
        Object.assign(items)
            .map((element) => {
                return element;
            })
            .filter((key) => key.manufacturerData)
            .map((element) => {
                return element.manufacturerData;
            })
            .flat();

    const manufacturerSliderEnabled = manufacturerElements && manufacturerElements.length > 0;
    const listingBannerConfig = items.find(item => item.listingbannerData);

    return (
        <div className="search-content" data-insights-index={SEARCH_INDEX}>
            {isNotMobile && listingBannerConfig ?<ListingBanner
                listingBannerConfig={listingBannerConfig} /> : null}
            {isNotMobile && manufacturerSliderEnabled ? <ManufacturerSlider /> : null}
            <CurrentRefinementsList />
            <NoResultsBoundary
                className="search-empty"
                fallback={<NoResults />}
            />
            <CustomHits />

            {canRefine ? <CustomPagination className="search-pagination" /> : null}

        </div>
    );
};

export default HitListing;
